export const TABLE_GROUP_TYPE = 'group';
